// import 'jquery';
import './05-objects/blog-list';
import './05-objects/caroussel';
import './05-objects/glossary';
import './05-objects/menu';
import './05-objects/image-changer';
// import './mapbox';
